import React from 'react';
import PropTypes from 'prop-types';
import { withFormik, Form } from 'formik';

import { useAction } from 'app/hooks';

import { SaveButton, RedirectButton } from 'components';
import { actions as campaignsActions } from 'ducks/campaigns';
import { promotionFormValidationSchema } from 'ducks/campaigns/validation';
import { mapPromotionToValues } from 'ducks/campaigns/helpers';
import paths from 'app/paths';

import { PromotionEditGeneral, PromotionEditRules } from '../PromotionEdit';
import PromotionCheapestItemDiscountAction from './PromotionCheapestItemDiscountAction';

const PromotionForm = React.memo(({ promotion }) => {
  return (
    <Form>
      <PromotionEditGeneral promotion={promotion} />
      <PromotionEditRules promotion={promotion} />
      <PromotionCheapestItemDiscountAction />
      <SaveButton label="app:create" />
      <RedirectButton marginLeft label="app:cancel" path={paths.promotions.path} />
    </Form>
  );
});

PromotionForm.propTypes = {
  promotion: PropTypes.object.isRequired,
};

const EnhancedPromotionForm = withFormik({
  displayName: 'PromotionCheapestItemDiscountForm',
  validationSchema: promotionFormValidationSchema,
  enableReinitialize: true,
  validateOnBlur: false,
  validateOnChange: false,
  mapPropsToValues: mapPromotionToValues,
  handleSubmit: (values, { props }) => {
    const { onSubmit, promotion } = props;
    onSubmit({ ...values, campaign: promotion.id });
  },
})(PromotionForm);

EnhancedPromotionForm.propTypes = {
  promotion: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const PromotionCreateCheapestItemDiscount = React.memo((props) => {
  const createCheapest = useAction(campaignsActions.createCheapestItemDiscountPromotion);

  return <EnhancedPromotionForm {...props} onSubmit={createCheapest} />;
});

PromotionCreateCheapestItemDiscount.propTypes = {
  promotion: PropTypes.object.isRequired,
};

export default PromotionCreateCheapestItemDiscount;
